import type { Locale } from './types';

export const baseTranslations: Record<Locale, Record<string, string>> = {
  ru: {
    'app.loading': 'Загрузка приложения…',
    'app.language.label': 'Язык',
    'app.language.ariaLabel': 'Выбрать язык интерфейса',
    'app.language.ru': 'RU',
    'app.language.en': 'EN',
    'app.language.id': 'ID',
    'layout.context.empty': 'Контекст не выбран',
    'layout.context.organization': 'Организация',
    'layout.context.outlet': 'Outlet',
    'layout.context.noOutlet': 'Без Outlet',
    'layout.context.noOutletsInOrg': 'Нет Outlet — создайте в настройках организации',
    'layout.context.compactLabel': '{organization} / {outlet}',
    'layout.context.selectOrganization': 'Выбрать организацию',
    'layout.context.selectOutlet': 'Выбрать Outlet',
    'layout.nav.operations': 'Операции',
    'layout.nav.dashboard': 'Dashboard',
    'layout.nav.accountantWorkbench': 'Рабочее место',
    'layout.nav.bankStatements': 'Банковские выписки',
    'layout.nav.nameMatching': 'Сопоставления',
    'layout.nav.counterpartyRules': 'Правила сопоставления',
    'layout.nav.bankTemplates': 'Загрузка банковской выписки',
    'layout.nav.manualCorrections': 'Корректировки',
    'layout.nav.auditLog': 'Журнал аудита',
    'layout.nav.syrveReconciliation': 'Накладные Syrve',
    'layout.nav.syrveDocuments': 'Накладные',
    'layout.nav.syrveUnpaid': 'Не оплачено',
    'layout.nav.syrvePartiallyPaid': 'Частично оплачено',
    'layout.nav.syrvePaid': 'Оплачено',
    'layout.nav.allocation': 'Оплаты Syrve',
    'layout.nav.allocations': 'Распределения',
    'layout.nav.allocationReview': 'Проверка',
    'layout.nav.paymentPosting': 'Проведение оплат',
    'layout.nav.advanced': 'Расширенное',
    'layout.nav.postingQueue': 'Очередь',
    'layout.nav.paymentAnomalies': 'Аномалии',
    'layout.nav.reconciliation': 'Сверка',
    'layout.nav.hub.imports': 'Выписки',
    'layout.nav.hub.matching': 'Сопоставление',
    'layout.nav.hub.rules': 'Правила',
    'layout.nav.hub.title': 'Банковские выписки',
    'layout.nav.hub.subtitle': 'Загрузка, список импортов, сопоставление контрагентов и правила',
    'layout.nav.syrveIiko': 'Syrve',
    'layout.nav.organization': 'Организация',
    'layout.nav.organizationUsers': 'Пользователи',
    'layout.nav.platform': 'Платформа',
    'layout.nav.connections': 'Syrve подключения',
    'layout.nav.syncStatus': 'Статус sync',
    'layout.nav.references': 'Счета и ДДС',
    'layout.nav.bankAccounts': 'Счета банка',
    'layout.nav.settings': 'Настройки',
    'layout.nav.telegram': 'Telegram',
    'layout.nav.bankAdapters': 'Банковские адаптеры',
    'layout.nav.platformOrganizations': 'Организации',
    'layout.nav.platformUsers': 'Пользователи',
    'layout.nav.platformSettings': 'Настройки платформы',
    'layout.nav.workers': 'Workers',
    'layout.nav.logout': 'Выйти',
    'layout.nav.changeContext': 'Сменить контекст',
    'layout.nav.openNavigation': 'Открыть навигацию',
    'layout.sidebar.collapse': 'Свернуть меню',
    'layout.sidebar.expand': 'Развернуть меню',
    'dashboard.loading': 'Загружаем задачи на сегодня…',
    'dashboard.error': 'Не удалось загрузить dashboard',
    'dashboard.contextRequired.title': 'Выберите Outlet',
    'dashboard.contextRequired.message': 'Для операционных разделов выберите организацию и Outlet в шапке страницы.',
    'dashboard.title': 'Сегодня / Требует внимания',
    'dashboard.subtitle': 'Операционный обзор: что нужно сделать прямо сейчас',
    'dashboard.actions.upload': 'Загрузить выписку',
    'dashboard.actions.unmatched': 'Unmatched',
    'dashboard.actions.ready': 'Готово к подтверждению',
    'dashboard.cards.newImports.title': 'Новые импорты',
    'dashboard.cards.newImports.description': 'Загруженные выписки, ожидающие обработки',
    'dashboard.cards.unmatched.title': 'Без контрагента',
    'dashboard.cards.unmatched.description': 'Требуют ручного сопоставления',
    'dashboard.cards.lowConfidence.title': 'Низкая уверенность',
    'dashboard.cards.lowConfidence.description': 'Проверьте контрагента перед оплатой',
    'dashboard.cards.ready.title': 'К подтверждению',
    'dashboard.cards.ready.description': 'Распределения, готовые к подтверждению',
    'dashboard.cards.failedPostings.title': 'Ошибки отправки',
    'dashboard.cards.failedPostings.description': 'Платежи не отправлены в Syrve',
    'dashboard.cards.successfulPostings.title': 'Успешные отправки',
    'dashboard.cards.successfulPostings.description': 'За последние 7 дней',
    'dashboard.activity.title': 'Активность за 7 дней',
    'dashboard.activity.subtitle': 'Сводка операционных показателей за последнюю неделю',
    'dashboard.syrveSync.title': 'Данные Syrve',
    'dashboard.syrveSync.subtitle': 'Документы и контрагенты обновляются одной кнопкой. Полная пересинхронизация каталога — по ссылке под кнопкой.',
    'dashboard.syrveSync.incremental': 'Обновить документы и контрагентов',
    'dashboard.syrveSync.fullSuppliers': 'Полная пересинхронизация контрагентов',
    'dashboard.syrveSync.noConnection': 'Нет активного подключения Syrve — обратитесь к администратору организации.',
    'dashboard.syrveSync.successIncremental': 'Синхронизация документов и контрагентов запущена.',
    'dashboard.syrveSync.successFullSuppliers': 'Полная пересинхронизация контрагентов запущена.',
    'dashboard.syrveSync.error': 'Не удалось запустить синхронизацию Syrve.',
    'dashboard.syrveSync.inProgress': 'Синхронизация Syrve выполняется…',
    'dashboard.syrveSync.inProgressFull': 'Полная пересинхронизация контрагентов выполняется…',
    'notifications.ariaLabel': 'Уведомления',
    'notifications.slaLabel': 'SLA',
    'notifications.loading': 'Загружаем уведомления…',
    'notifications.empty': 'Нет новых уведомлений',
    'notifications.allItems': 'Все уведомления и аномалии',
    'notifications.severity.Info': 'инфо',
    'notifications.severity.Warning': 'внимание',
    'notifications.severity.Critical': 'критично',
    'notifications.owner': 'Владелец',
    'notifications.ownerUnassigned': 'не назначен',
    'notifications.escalatedAt': 'эскалировано',
    'notifications.slaDue': 'SLA до',
    'notifications.open': 'Открыть',
    'notifications.assignMe': 'Назначить мне',
    'notifications.acknowledge': 'Принять',
    'notifications.resolve': 'Решено',
    'notifications.dismiss': 'Скрыть',
    'notifications.markRead': 'Прочитано',
    'notifications.allAnomalies': 'Все аномалии',
    'notifications.sla.Open': 'открыто',
    'notifications.sla.Acknowledged': 'принято',
    'notifications.sla.Escalated': 'эскалировано',
    'notifications.sla.Resolved': 'решено',
    'notifications.sla.Dismissed': 'скрыто',
    'reports.reconciliationEvidence.csvButton': 'CSV evidence',
    'reports.reconciliationEvidence.subtitle': 'Экспорт evidence по распределению, проведению, readback и сверке',
  },
  en: {
    'app.loading': 'Loading application…',
    'app.language.label': 'Language',
    'app.language.ariaLabel': 'Select interface language',
    'app.language.ru': 'RU',
    'app.language.en': 'EN',
    'app.language.id': 'ID',
    'layout.context.empty': 'Context is not selected',
    'layout.context.organization': 'Organization',
    'layout.context.outlet': 'Outlet',
    'layout.context.noOutlet': 'No Outlet',
    'layout.context.noOutletsInOrg': 'No Outlets — create one in organization settings',
    'layout.context.compactLabel': '{organization} / {outlet}',
    'layout.context.selectOrganization': 'Select organization',
    'layout.context.selectOutlet': 'Select Outlet',
    'layout.nav.operations': 'Operations',
    'layout.nav.dashboard': 'Dashboard',
    'layout.nav.accountantWorkbench': 'Accountant workbench',
    'layout.nav.bankStatements': 'Bank statements',
    'layout.nav.nameMatching': 'Matching',
    'layout.nav.counterpartyRules': 'Matching rules',
    'layout.nav.bankTemplates': 'Upload bank statement',
    'layout.nav.manualCorrections': 'Corrections',
    'layout.nav.auditLog': 'Audit log',
    'layout.nav.syrveReconciliation': 'Syrve documents',
    'layout.nav.syrveDocuments': 'Documents',
    'layout.nav.syrveUnpaid': 'Unpaid',
    'layout.nav.syrvePartiallyPaid': 'Partially paid',
    'layout.nav.syrvePaid': 'Paid',
    'layout.nav.allocation': 'Syrve payments',
    'layout.nav.allocations': 'Allocations',
    'layout.nav.allocationReview': 'Review',
    'layout.nav.paymentPosting': 'Payment posting',
    'layout.nav.advanced': 'Advanced',
    'layout.nav.postingQueue': 'Queue',
    'layout.nav.paymentAnomalies': 'Anomalies',
    'layout.nav.reconciliation': 'Reconciliation',
    'layout.nav.hub.imports': 'Statements',
    'layout.nav.hub.matching': 'Matching',
    'layout.nav.hub.rules': 'Rules',
    'layout.nav.hub.title': 'Bank statements',
    'layout.nav.hub.subtitle': 'Upload, import list, counterparty matching and rules',
    'layout.nav.syrveIiko': 'Syrve',
    'layout.nav.organization': 'Organization',
    'layout.nav.organizationUsers': 'Users',
    'layout.nav.platform': 'Platform',
    'layout.nav.connections': 'Syrve connections',
    'layout.nav.syncStatus': 'Sync status',
    'layout.nav.references': 'Accounts and cash flow',
    'layout.nav.bankAccounts': 'Bank accounts',
    'layout.nav.settings': 'Settings',
    'layout.nav.telegram': 'Telegram',
    'layout.nav.bankAdapters': 'Bank adapters',
    'layout.nav.platformOrganizations': 'Organizations',
    'layout.nav.platformUsers': 'Users',
    'layout.nav.platformSettings': 'Platform settings',
    'layout.nav.workers': 'Workers',
    'layout.nav.logout': 'Log out',
    'layout.nav.changeContext': 'Change context',
    'layout.nav.openNavigation': 'Open navigation',
    'layout.sidebar.collapse': 'Collapse menu',
    'layout.sidebar.expand': 'Expand menu',
    'dashboard.loading': 'Loading today’s tasks…',
    'dashboard.error': 'Failed to load dashboard',
    'dashboard.contextRequired.title': 'Select an Outlet',
    'dashboard.contextRequired.message': 'Choose organization and Outlet in the page header for operational sections.',
    'dashboard.title': 'Today / Needs attention',
    'dashboard.subtitle': 'Operational overview: what needs action now',
    'dashboard.actions.upload': 'Upload statement',
    'dashboard.actions.unmatched': 'Unmatched',
    'dashboard.actions.ready': 'Ready to confirm',
    'dashboard.cards.newImports.title': 'New imports',
    'dashboard.cards.newImports.description': 'Uploaded statements waiting for processing',
    'dashboard.cards.unmatched.title': 'No counterparty',
    'dashboard.cards.unmatched.description': 'Require manual matching',
    'dashboard.cards.lowConfidence.title': 'Low confidence',
    'dashboard.cards.lowConfidence.description': 'Review the counterparty before payment',
    'dashboard.cards.ready.title': 'Ready to confirm',
    'dashboard.cards.ready.description': 'Allocations ready for confirmation',
    'dashboard.cards.failedPostings.title': 'Posting errors',
    'dashboard.cards.failedPostings.description': 'Payments were not sent to Syrve',
    'dashboard.cards.successfulPostings.title': 'Successful postings',
    'dashboard.cards.successfulPostings.description': 'Over the last 7 days',
    'dashboard.activity.title': 'Activity over 7 days',
    'dashboard.activity.subtitle': 'Operational metrics summary for the last week',
    'dashboard.syrveSync.title': 'Syrve data',
    'dashboard.syrveSync.subtitle': 'Manual refresh of documents and counterparties from the default connection. Full resync reloads the entire supplier catalog.',
    'dashboard.syrveSync.incremental': 'Refresh documents and counterparties',
    'dashboard.syrveSync.fullSuppliers': 'Full counterparty resync',
    'dashboard.syrveSync.noConnection': 'No active Syrve connection — contact your organization admin.',
    'dashboard.syrveSync.successIncremental': 'Document and counterparty sync started.',
    'dashboard.syrveSync.successFullSuppliers': 'Full counterparty resync started.',
    'dashboard.syrveSync.error': 'Failed to start Syrve sync.',
    'dashboard.syrveSync.inProgress': 'Syrve sync in progress…',
    'dashboard.syrveSync.inProgressFull': 'Full counterparty resync in progress…',
    'notifications.ariaLabel': 'Notifications',
    'notifications.slaLabel': 'SLA',
    'notifications.loading': 'Loading notifications…',
    'notifications.empty': 'No new notifications',
    'notifications.allItems': 'All notifications and anomalies',
    'notifications.severity.Info': 'info',
    'notifications.severity.Warning': 'warning',
    'notifications.severity.Critical': 'critical',
    'notifications.owner': 'Owner',
    'notifications.ownerUnassigned': 'unassigned',
    'notifications.escalatedAt': 'escalated',
    'notifications.slaDue': 'SLA due',
    'notifications.open': 'Open',
    'notifications.assignMe': 'Assign to me',
    'notifications.acknowledge': 'Acknowledge',
    'notifications.resolve': 'Resolved',
    'notifications.dismiss': 'Dismiss',
    'notifications.markRead': 'Read',
    'notifications.allAnomalies': 'All anomalies',
    'notifications.sla.Open': 'open',
    'notifications.sla.Acknowledged': 'acknowledged',
    'notifications.sla.Escalated': 'escalated',
    'notifications.sla.Resolved': 'resolved',
    'notifications.sla.Dismissed': 'dismissed',
    'reports.reconciliationEvidence.csvButton': 'CSV evidence',
    'reports.reconciliationEvidence.subtitle': 'Export evidence for allocation, posting, readback, and reconciliation',
  },
  id: {
    'app.loading': 'Memuat aplikasi…',
    'app.language.label': 'Bahasa',
    'app.language.ariaLabel': 'Pilih bahasa antarmuka',
    'app.language.ru': 'RU',
    'app.language.en': 'EN',
    'app.language.id': 'ID',
    'layout.context.empty': 'Konteks belum dipilih',
    'layout.context.organization': 'Organization',
    'layout.context.outlet': 'Outlet',
    'layout.context.noOutlet': 'Tanpa Outlet',
    'layout.context.noOutletsInOrg': 'Tidak ada Outlet — buat di pengaturan organisasi',
    'layout.context.compactLabel': '{organization} / {outlet}',
    'layout.context.selectOrganization': 'Pilih organization',
    'layout.context.selectOutlet': 'Pilih Outlet',
    'layout.nav.operations': 'Operasi',
    'layout.nav.dashboard': 'Dashboard',
    'layout.nav.accountantWorkbench': 'Meja kerja akuntan',
    'layout.nav.bankStatements': 'Rekening koran',
    'layout.nav.nameMatching': 'Pencocokan',
    'layout.nav.counterpartyRules': 'Aturan pencocokan',
    'layout.nav.bankTemplates': 'Unggah rekening koran',
    'layout.nav.manualCorrections': 'Koreksi',
    'layout.nav.auditLog': 'Log audit',
    'layout.nav.syrveReconciliation': 'Dokumen Syrve',
    'layout.nav.syrveDocuments': 'Dokumen',
    'layout.nav.syrveUnpaid': 'Belum dibayar',
    'layout.nav.syrvePartiallyPaid': 'Dibayar sebagian',
    'layout.nav.syrvePaid': 'Dibayar',
    'layout.nav.allocation': 'Pembayaran Syrve',
    'layout.nav.allocations': 'Alokasi',
    'layout.nav.allocationReview': 'Pemeriksaan',
    'layout.nav.paymentPosting': 'Posting pembayaran',
    'layout.nav.advanced': 'Lanjutan',
    'layout.nav.postingQueue': 'Antrean',
    'layout.nav.paymentAnomalies': 'Anomali',
    'layout.nav.reconciliation': 'Rekonsiliasi',
    'layout.nav.hub.imports': 'Rekening koran',
    'layout.nav.hub.matching': 'Pencocokan',
    'layout.nav.hub.rules': 'Aturan',
    'layout.nav.hub.title': 'Rekening koran',
    'layout.nav.hub.subtitle': 'Unggah, daftar impor, pencocokan counterparty dan aturan',
    'layout.nav.syrveIiko': 'Syrve',
    'layout.nav.organization': 'Organisasi',
    'layout.nav.organizationUsers': 'Pengguna',
    'layout.nav.platform': 'Platform',
    'layout.nav.connections': 'Koneksi Syrve',
    'layout.nav.syncStatus': 'Status sinkronisasi',
    'layout.nav.references': 'Akun dan arus kas',
    'layout.nav.bankAccounts': 'Rekening bank',
    'layout.nav.settings': 'Pengaturan',
    'layout.nav.telegram': 'Telegram',
    'layout.nav.bankAdapters': 'Adaptor bank',
    'layout.nav.platformOrganizations': 'Organisasi',
    'layout.nav.platformUsers': 'Pengguna',
    'layout.nav.platformSettings': 'Platform settings',
    'layout.nav.workers': 'Workers',
    'layout.nav.logout': 'Keluar',
    'layout.nav.changeContext': 'Ganti konteks',
    'layout.nav.openNavigation': 'Buka navigasi',
    'layout.sidebar.collapse': 'Ciutkan menu',
    'layout.sidebar.expand': 'Perluas menu',
    'dashboard.loading': 'Memuat tugas hari ini…',
    'dashboard.error': 'Gagal memuat dashboard',
    'dashboard.contextRequired.title': 'Pilih Outlet',
    'dashboard.contextRequired.message': 'Pilih organization dan Outlet di header halaman untuk bagian operasional.',
    'dashboard.title': 'Hari ini / Perlu perhatian',
    'dashboard.subtitle': 'Ringkasan operasional: tindakan yang perlu dilakukan sekarang',
    'dashboard.actions.upload': 'Unggah rekening koran',
    'dashboard.actions.unmatched': 'Belum cocok',
    'dashboard.actions.ready': 'Siap dikonfirmasi',
    'dashboard.cards.newImports.title': 'Impor baru',
    'dashboard.cards.newImports.description': 'Rekening koran yang menunggu diproses',
    'dashboard.cards.unmatched.title': 'Tanpa counterparty',
    'dashboard.cards.unmatched.description': 'Perlu pencocokan manual',
    'dashboard.cards.lowConfidence.title': 'Kepercayaan rendah',
    'dashboard.cards.lowConfidence.description': 'Periksa counterparty sebelum pembayaran',
    'dashboard.cards.ready.title': 'Siap dikonfirmasi',
    'dashboard.cards.ready.description': 'Alokasi siap dikonfirmasi',
    'dashboard.cards.failedPostings.title': 'Kesalahan posting',
    'dashboard.cards.failedPostings.description': 'Pembayaran tidak terkirim ke Syrve',
    'dashboard.cards.successfulPostings.title': 'Posting berhasil',
    'dashboard.cards.successfulPostings.description': 'Dalam 7 hari terakhir',
    'dashboard.activity.title': 'Aktivitas 7 hari',
    'dashboard.activity.subtitle': 'Ringkasan metrik operasional minggu terakhir',
    'dashboard.syrveSync.title': 'Data Syrve',
    'dashboard.syrveSync.subtitle': 'Pembaruan manual dokumen dan counterparty dari koneksi default. Resync penuh memuat ulang seluruh katalog supplier.',
    'dashboard.syrveSync.incremental': 'Perbarui dokumen dan counterparty',
    'dashboard.syrveSync.fullSuppliers': 'Resync counterparty penuh',
    'dashboard.syrveSync.noConnection': 'Tidak ada koneksi Syrve aktif — hubungi admin organisasi.',
    'dashboard.syrveSync.successIncremental': 'Sinkronisasi dokumen dan counterparty dimulai.',
    'dashboard.syrveSync.successFullSuppliers': 'Resync counterparty penuh dimulai.',
    'dashboard.syrveSync.error': 'Gagal memulai sinkronisasi Syrve.',
    'dashboard.syrveSync.inProgress': 'Sinkronisasi Syrve berjalan…',
    'dashboard.syrveSync.inProgressFull': 'Resync counterparty penuh berjalan…',
    'notifications.ariaLabel': 'Notifikasi',
    'notifications.slaLabel': 'SLA',
    'notifications.loading': 'Memuat notifikasi…',
    'notifications.empty': 'Tidak ada notifikasi baru',
    'notifications.allItems': 'Semua notifikasi dan anomali',
    'notifications.severity.Info': 'info',
    'notifications.severity.Warning': 'peringatan',
    'notifications.severity.Critical': 'kritis',
    'notifications.owner': 'Pemilik',
    'notifications.ownerUnassigned': 'belum ditetapkan',
    'notifications.escalatedAt': 'dieskalasi',
    'notifications.slaDue': 'SLA sampai',
    'notifications.open': 'Buka',
    'notifications.assignMe': 'Tetapkan ke saya',
    'notifications.acknowledge': 'Terima',
    'notifications.resolve': 'Selesai',
    'notifications.dismiss': 'Sembunyikan',
    'notifications.markRead': 'Dibaca',
    'notifications.allAnomalies': 'Semua anomali',
    'notifications.sla.Open': 'terbuka',
    'notifications.sla.Acknowledged': 'diterima',
    'notifications.sla.Escalated': 'dieskalasi',
    'notifications.sla.Resolved': 'selesai',
    'notifications.sla.Dismissed': 'disembunyikan',
    'reports.reconciliationEvidence.csvButton': 'CSV evidence',
    'reports.reconciliationEvidence.subtitle': 'Ekspor evidence untuk alokasi, posting, readback, dan rekonsiliasi',
  },
};
